import { useLocation } from 'react-router';

import { addons } from '#addons';
import { renderAddonDetail, type Addon } from './common';

export default function AddonDetail() {
  const location = useLocation();

  const [, addonId] = location.search.match(/addonId=(\S+)/i) || [];

  if (!addonId) {
    return <>Not find addon id</>;
  }

  const addon = addons.find((ad) => ad.info.id === addonId);
  if (!addon) {
    return <>Invalid addon id</>;
  }

  return (renderAddonDetail({
    addon: addon as unknown as Addon,
    details: true,
  }));
}
